import { isEqual } from 'lodash';
import { useCallback, useMemo, useState } from 'react';
import useAsync from 'src/hooks/useAsync';
import { IReceipt as ReceiptDetailsResponse } from 'src/types/Receipt';
import axiosInstance from 'src/utils/axios';

const useReceiptDetailsApi = (receiptId?: string) => {
  const [initialReceipt, setInitialReceipt] = useState({} as ReceiptDetailsResponse);

  const call = useCallback(async () => {
    try {
      const res = await axiosInstance.get<ReceiptDetailsResponse>(`Receipt/${receiptId}`);
      const response: ReceiptDetailsResponse = {
        ...res.data,
        _deliveryDateTime: res.data.deliveryDateTime,
        _documentDate: res.data.documentDate,
      };
      setInitialReceipt(response);
      return response as ReceiptDetailsResponse;
    } catch (error) {
      throw new Error(error);
    }
  }, [receiptId]);

  const { value, setValue, execute, isLoading } = useAsync(
    call,
    true,
    undefined,
    {} as ReceiptDetailsResponse
  );

  const isReceiptDirty = useMemo(() => !isEqual(initialReceipt, value), [initialReceipt, value]);

  return {
    receiptData: value,
    setReceiptData: setValue,
    getReceiptData: execute,
    receiptDataLoading: isLoading,
    isReceiptDirty,
  };
};

export default useReceiptDetailsApi;
